var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-list",
    { attrs: { dense: "" } },
    [
      _c(
        "v-list-tile",
        [
          _c("v-list-tile-content", [_vm._v("Key")]),
          _vm._v(" "),
          _c("v-list-tile-content", { staticClass: "align-end" }, [
            _vm._v("Value"),
          ]),
          _vm._v(" "),
          _c("v-list-tile-avatar", [_vm._v("Info")]),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(Object.keys(_vm.kvStore.Data), function (k, i) {
        return _c(
          "v-list-tile",
          { key: `row-${i}` },
          [
            _c("v-list-tile-content", [_vm._v(_vm._s(k))]),
            _vm._v(" "),
            _c("v-list-tile-content", { staticClass: "align-end" }, [
              _vm._v(_vm._s(_vm._calculateDisplayValue(_vm.kvStore.Data[k]))),
            ]),
            _vm._v(" "),
            _c(
              "v-list-tile-avatar",
              [
                _c(
                  "v-btn",
                  {
                    attrs: { flat: "", icon: "" },
                    on: {
                      click: function ($event) {
                        return _vm.handleShowInfo(k, _vm.kvStore.Data[k])
                      },
                    },
                  },
                  [_c("v-icon", [_vm._v("info")])],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
      _vm._v(" "),
      _c("KVPairInfoModal", {
        key: `metadata-info-${_vm.kvStore.Id}`,
        attrs: {
          kvValue: _vm.showInfoKVValue,
          kvPairKey: _vm.showInfoKVPairKey,
        },
        model: {
          value: _vm.showInfo,
          callback: function ($$v) {
            _vm.showInfo = $$v
          },
          expression: "showInfo",
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }